import { IDexPairShort, IProjectPairShort } from 'types/pairs';
import { EExchange } from 'web3';

type GetPairsByProject = (args: { id: number }) => Promise<{
  isSuccess: boolean;
  data?: { items: IProjectPairShort[] };
}>;

interface ResolveSolPairArgs {
  cachedPair?: IDexPairShort;
  getPairsByProject: GetPairsByProject;
  pairId: number;
  projectId: number;
}

export async function resolveSolPair({
  cachedPair,
  getPairsByProject,
  pairId,
  projectId,
}: ResolveSolPairArgs): Promise<IDexPairShort | undefined> {
  if (cachedPair?.id === pairId) {
    return cachedPair;
  }

  const result = await getPairsByProject({ id: projectId });
  if (!result.isSuccess) {
    return undefined;
  }

  return result.data?.items.find(item => item.type === EExchange.sol && item.sol_pair?.id === pairId)
    ?.sol_pair;
}
